module.exports = __webpack_public_path__ + "img/icon-global.c973f35a.svg";